import { render, staticRenderFns } from "./recover_psw.vue?vue&type=template&id=6e88aff6"
import script from "./recover_psw.vue?vue&type=script&lang=js"
export * from "./recover_psw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports